import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useChat, useAuth } from '@carcareers/contexts';
import { routes } from '@carcareers/utils';

export const ChatHeader: FC = () => {
  const { selectedRoom, setSelectedRoom } = useChat();
  const { user } = useAuth();
  const navigate = useNavigate();

  const isEmployer = user?.role === 'employer';
  const backUrl = isEmployer ? routes.EMPLOYER_HOME : routes.JOBSEEKER_HOME;

  const handleBackToList = () => {
    setSelectedRoom(null);
    navigate(`/${backUrl}/${routes.JOBSEEKER_CHAT}`);
  };

  if (!selectedRoom) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #e0e0e0' }}>
      <IconButton sx={{ display: { xs: 'flex', md: 'none' } }} onClick={handleBackToList}>
        <ArrowBackIcon />
      </IconButton>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!isEmployer && (
            <Typography variant="body1">{selectedRoom.employer_name} at {selectedRoom.rooftop_name}</Typography>
          )}
          {isEmployer && (
            <Typography variant="body1">{selectedRoom.jobseeker_name}</Typography>
          )}
        </Box>
        <Typography variant="caption">{selectedRoom.job_title}</Typography>
      </Box>
    </Box>
  );
};

export default ChatHeader;
